// PrivateMoney.type の enum: admin OpenAPI schema 上 "own" | "third-party"
export const PRIVATE_MONEY_TYPE = {
  OWN: 'own',
  THIRD_PARTY: 'third-party',
} as const;
